import React from "react"
import "./main.css"
import logo from "./logo.png"

export default () => 
    <div className="App">
        <img src={logo} className="App-logo" alt="logo" />
    </div>



// WEBPACK FOOTER //
// ./src/pages/index.js